import WrapedCheckbox from './WrapedCheckbox';
export default WrapedCheckbox;
